export default __webpack_public_path__ + "static/media/exp1.4e0971d0.svg";